import React, { useState, useEffect } from "react";
import { IonIcon } from "@ionic/react";
import { star, starOutline } from "ionicons/icons";

const StarsRating = ({
  rating = 0,
  onRatingChange,
  readonly = false,
  size = "small", // "small" | "medium" | "large"
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  const [currentRating, setCurrentRating] = useState(rating);

  useEffect(() => {
    setCurrentRating(rating);
  }, [rating]);

  const handleStarClick = (starValue) => {
    if (readonly) return;

    setCurrentRating(starValue);
    if (onRatingChange) {
      onRatingChange(starValue);
    }
  };

  const handleStarHover = (starValue) => {
    if (readonly) return;
    setHoverRating(starValue);
  };

  const handleMouseLeave = () => {
    if (readonly) return;
    setHoverRating(0);
  };

  const getStarIcon = (starIndex) => {
    const effectiveRating = hoverRating || currentRating;
    return starIndex <= effectiveRating ? star : starOutline;
  };

  const getStarClass = (starIndex) => {
    const effectiveRating = hoverRating || currentRating;
    const baseClass = "star";
    const filledClass =
      starIndex <= effectiveRating ? "star-filled" : "star-empty";
    return `${baseClass} ${filledClass} ${size}`;
  };

  return (
    <div
      className="max-content display-flex align-items-c"
      style={{ gap: "2px" }}
      onMouseLeave={handleMouseLeave}
    >
      {[1, 2, 3, 4, 5].map((starValue) => (
        <div
          key={starValue}
          style={{ cursor: readonly ? "default" : "pointer", lineHeight: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleStarClick(starValue);
          }}
          onMouseEnter={() => handleStarHover(starValue)}
        >
          <IonIcon
            icon={getStarIcon(starValue)}
            className={getStarClass(starValue)}
            style={{
              fontSize: size === "small" ? "16px" : "24px",
              color:
                getStarIcon(starValue) === star ? "var(--main-color)" : "#ccc",
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default StarsRating;

